module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-cell"
  }, [_c('mt-cell', {
    attrs: {
      "title": "单一cell组件使用",
      "wrapperpaddingleft": "20px",
      "is-link": ""
    }
  }), _vm._v(" "), _c('mt-cell-group', {
    attrs: {
      "title": "cell组的标题"
    }
  }, [_c('mt-cell', {
    attrs: {
      "title": "标题文字"
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题文字",
      "value": "说明文字"
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题文字",
      "icon": "more",
      "value": "带 icon"
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题文字",
      "value": "icon 是自定义图片"
    }
  }, [_c('mt-image', {
    attrs: {
      "slot": "icon",
      "src": "http://res.wisedu.com/fe_components/images/errorTip/System_upgrade.png",
      "width": "24px",
      "height": "24px",
      "smile-display": "inline-block"
    },
    slot: "icon"
  })], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题文字",
      "is-link": "",
      "value": "带链接的",
      "wrapperpaddingright": "15px",
      "arrowdefined": ""
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-localgrocerystore",
    staticStyle: {
      "font-size": "24px",
      "color": "#bdc0c5"
    },
    attrs: {
      "slot": "arrowdefined"
    },
    slot: "arrowdefined"
  })]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题文字",
      "is-link": "",
      "wrapperpaddingright": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("自定义右内边距30px")])]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题文字",
      "to": "click",
      "wrapperpaddingright": "15px"
    },
    on: {
      "cellClick": _vm.cellClick
    }
  }, [_c('mt-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "back"
    }
  }, [_vm._v("按钮")])], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题",
      "label": "描述信息",
      "is-link": ""
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "原生跳转",
      "label": "跳转到 https://bh-mint-ui2.github.io",
      "is-link": "",
      "to": "https://bh-mint-ui2.github.io"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f235b16","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/cell.vue
// module id = 108
// module chunks = 0